export default __webpack_public_path__ + "static/0095-67c9ab50a1d15234dd93d9ad4cc35ace.png";